export enum ActivityTypes {
  BREAK = 1,
  MAINTENANCE = 2
}
